var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTj(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#060",
    d: "M0 0h53.3v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h53.3v28.6H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c00",
    d: "M0 0h53.3v11.4H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f8c300",
    d: "M25 19.5a.7.7 0 0 1 1.4.3v2.9h.5v-2.9a.7.7 0 0 1 1.4-.3 1.7 1.7 0 1 0-3.2 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.5 18.7a1 1 0 0 1 1.2.6 1 1 0 0 1 1.2-.6 1.2 1.2 0 0 0-2.4 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f8c300",
    d: "M26.4 21.5a2.2 2.2 0 0 1-3.6 1.4 2.3 2.3 0 0 1-3.5 1c.2 2 3.4 1.7 3.6-.4 1 1.8 3.1 1.3 3.8-.8zm.6 0a2.2 2.2 0 0 0 3.6 1.4 2.2 2.2 0 0 0 3.4 1c-.2 2-3.3 1.7-3.6-.4-1 1.8-3.1 1.3-3.7-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f8c300",
    d: "M24.3 25.2q-.8 1.5-2 .4 0-.2.6-.3 0-.5.2-.8.4.2.5.6zm3.4-.1q-1 1.3-2 0l.6-.2q0-.4.4-.7l.4.7zm3.3.5q-1 1-2-.4h.7q.1-.5.5-.7.3.3.3.8.6.1.6.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#f8c300",
    strokeWidth: 1.4,
    d: "M21.1 27.3q5.6-1.5 11.1 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f8c300",
    d: "m27.5 14.9-2.2-1.6H28l-2.3 1.6.9-2.7zm-4 1.1-2.2-1.7H24L21.8 16l.9-2.7zm-2.9 2.9-2.3-1.6h2.8L19 18.9l.8-2.7zm-1.1 4-2.2-1.6H20l-2.3 1.6.9-2.7zM29.8 16l2.3-1.7h-2.8l2.2 1.7-.8-2.7zm2.9 2.9 2.3-1.6h-2.8l2.3 1.6-1-2.7zm1.1 4 2.3-1.6h-2.8l2.2 1.6-.8-2.7z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h53.3v40H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTj);
export default __webpack_public_path__ + "static/media/tj.3d70a882fbbf124634bd073a75cfcd6c.svg";
export { ForwardRef as ReactComponent };